import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";

import { i18n } from "services/i18nService";

export function ConcurrencyModal(props) {
  const { onOverwrite, onRefresh, objectType } = props;
  const objectTypeLabel = i18n(`objectType.${objectType}.Lower`);

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography variant="h3">{i18n("concurrency.SaveConflict")}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>
          {i18n("concurrency.ConflictMessage", { objectType: objectTypeLabel })}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <Button color="secondary" onClick={onRefresh}>
          {i18n("concurrency.Discard")}
        </Button>
        <Button color="secondary" onClick={onOverwrite}>
          {i18n("concurrency.Overwrite")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
